import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Link } from '../../../components/Typography';
import { useConfig } from '../../../providers/ConfigProvider';

import styles from './RenterHeaderSettings.module.scss';

const PAGES = {
  ACCOUNT: 0,
  PAYMENT_METHODS: 1,
  AUTOPAY: 2,
  RENT_REPORTING: 3,
  RECEIPTS: 4,
};

const getSelectedIndex = (pathname) => {
  switch (pathname) {
    case '/renters/settings/account':
      return PAGES.ACCOUNT;
    case '/renters/settings/payment-methods':
      return PAGES.PAYMENT_METHODS;
    case '/renters/settings/autopay':
    case '/renters/settings/enroll-autopay':
      return PAGES.AUTOPAY;
    case '/renters/settings/billing':
    case '/renters/settings/rent-reporting':
      return PAGES.RENT_REPORTING;
    case '/renters/settings/receipts':
      return PAGES.RECEIPTS;
  }
  return -1;
};
const RenterHeaderSettings = ({ pathname }) => {
  const selectedIndex = getSelectedIndex(pathname);
  const { PRIVATE_BASE_PATH } = useConfig();

  const tabs = [
    {
      id: 'account_tab',
      label: 'Account',
      active: selectedIndex === PAGES.ACCOUNT,
      action: `account`,
    },
    {
      id: 'payments_tab',
      label: 'Payment Methods',
      active: selectedIndex === PAGES.PAYMENT_METHODS,
      action: `payment-methods`,
    },
    {
      id: 'autopay_tab',
      label: 'Autopay',
      active: selectedIndex === PAGES.AUTOPAY,
      action: `autopay`,
    },
    {
      id: 'rent_reporting_tab',
      label: 'Rent Reporting',
      active: selectedIndex === PAGES.RENT_REPORTING,
      action: `rent-reporting`,
    },
    {
      id: 'receipts_tab',
      label: 'Receipts',
      active: selectedIndex === PAGES.RECEIPTS,
      action: `receipts`,
    },
  ];

  return (
    <div className={styles.headerContainer}>
      <div className={styles.content}>
        {tabs.map((tab) => {
          const { id, label, action, active } = tab;

          return (
            <div
              key={id}
              className={cx(styles.itemStyles, {
                [styles.itemSelected]: active,
              })}
            >
              <Link
                uppercase
                to={`${PRIVATE_BASE_PATH}settings/${action}`}
                id={id}
              >
                {label}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

RenterHeaderSettings.propTypes = {
  pathname: PropTypes.string,
};

export default RenterHeaderSettings;
